import classNames from "classnames";
import { type CMSStandaloneImageDTO } from "../../dto";
import { resolveUrl } from "../../../utils/url/urlResolver";
import { CMSMedia } from "./CMSMedia";

import classes from "./CMSStandaloneMedia.module.less";

export interface CMSStandaloneImageProps extends Omit<CMSStandaloneImageDTO, "type"> {
  className?: string;
}

const ALIGNMENT_CLS = {
  LEFT: classes.alignLeft,
  CENTER: classes.alignCenter,
  RIGHT: classes.alignRight,
};
const WIDTH_CLS = {
  S100: classes.w100,
  S75: classes.w75,
  S50: classes.w50,
  S25: classes.w25,
};

export const CMSStandaloneImage = (props: CMSStandaloneImageProps) => {
  if (!props.media) {
    return null;
  }
  const { url, target, caption, className, alignment = "CENTER", size = "S100" } = props;

  let media = <CMSMedia {...props.media} className={props.className} />;
  if (url) {
    media = (
      <a href={resolveUrl(url)} target={target}>
        {media}
      </a>
    );
  }
  return (
    <div className={classNames("scha__cms", classes.root, ALIGNMENT_CLS[alignment], className)}>
      <figure className={WIDTH_CLS[size]}>
        {media}
        {!!caption && <figcaption className={classes.caption}>{caption}</figcaption>}
      </figure>
    </div>
  );
};
